<template>
  <div>
    <va-modal
      title="Fiche contact"
      class="modal"
      v-model="showEditorContact"
      :okText="saveContactMessage"
      cancelText="Annuler"
      v-on:ok="saveContact"
      v-on:cancel="closeModal"
    >
      <div class="row row-inside">
        <div class="flex md12">
          <div class="row row-inside mt-3">
            <div class="flex md3 padded-input">
              <va-select
                label="Titre"
                v-model="activeContact.titre"
                :options="titreOptions"
                no-clear
              />
            </div>
            <div class="flex md5 padded-input">
              <va-input
                v-model="activeContact.nom"
                placeholder="-"
                label="Nom"
                :error="validName"
              />
            </div>
            <div class="flex md4 padded-input">
              <va-input
                v-model="activeContact.prenom"
                placeholder="-"
                label="Prénom"
              />
            </div>
          </div>

          <div class="row row-inside">
            <div class="flex md5 padded-input">
              <va-input
                v-model="portableNumber"
                placeholder="Téléphone"
                label="Téléphone"
                :error="validPPhone"
                v-on:paste="trimOnPaste('portable')"
                v-on:focus="portableNumber = removeWhiteSpace(portableNumber)"
                v-on:blur="portableNumber = formatPhoneNumber(portableNumber)"
              />
            </div>
            <div class="flex md7 padded-input">
              <va-input
                v-model="activeContact.email"
                placeholder="-"
                label="Courriel"
              />
            </div>
          </div>

          <div class="row row-inside">
            <div class="flex md12 padded-input">
              <va-input
                v-model="activeContact.adresse"
                placeholder="Adresse inconnue"
                label="Adresse"
              />
            </div>

            <div class="flex md12 padded-input">
              <va-input
                v-model="activeContact.complement"
                placeholder="Complement d'adresse"
                label="Adresse suite"
              />
            </div>
            <div class="flex md2 padded-input">
              <va-input
                v-model="activeContact.code_postal"
                placeholder="Code Postal"
                label="Code Postal"
              />
            </div>
            <div class="flex md7 padded-input">
              <va-input
                v-model="activeContact.ville"
                placeholder="Ville"
                label="Ville"
              />
            </div>
            <div class="flex md3 padded-input">
              <va-input
                v-model="activeContact.cedex"
                placeholder="Cedex"
                label="Cedex"
              />
            </div>
          </div>

          <div class="row row-inside">
            <div class="flex md12">
              <va-input
                v-model="activeContact.note"
                label="Commentaire:"
                type="textarea"
                autosize
                :minRows="5"
                :maxRows="5"
              />
            </div>
          </div>
        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep, isEqual } from "lodash";
import { isPhoneNumber } from "../../services/utils";
export default {
  name: "contact-modal",
  props: ["idsyndicat", "showEditor"],

  data() {
    return {
      portableNumber: null,

      showEditorContact: false,
      titreOptions: ["MONSIEUR", "MADAME"],
      activeContact: {},
      originalContact: {},
      contactInfosUpdated: false,
    };
  },
  created() {
    this.initContact();
  },
  computed: {
    saveContactMessage: function () {
      return this.contactInfosUpdated
        ? "Sauvegarder les modifications"
        : "Fermer la fiche";
    },
    validName: function () {
      if (
        !this.activeContact.nom &&
        (this.activeContact.titre || this.activeContact.prenom)
      )
        return true;
      return false;
    },
    validPPhone: function () {
      if (this.activeContact.telephone) {
        return !isPhoneNumber(this.activeContact.telephone);
      }
      return false;
    },
  },
  watch: {
    activeContact: {
      deep: true,
      handler() {
        if (!isEqual(this.activeContact, this.originalContact)) {
          this.contactInfosUpdated = true;
        } else {
          this.contactInfosUpdated = false;
        }
      },
    },
    portableNumber(newNumber) {
      if (newNumber) {
        this.activeContact.telephone = this.removeWhiteSpace(newNumber);
      } else if (newNumber === null || newNumber === "") {
        this.activeContact.telephone = null;
      }
    },
    showEditor(newvalue) {
      if (newvalue === true) {
        this.getContact();
        this.showEditorContact = true;
      }
    },
  },
  methods: {
    async getContact() {
      try {
        let idorg;
        if (this.idsyndicat === "opam") {
          idorg = 2;
        } else if (this.idsyndicat === "agromer") {
          idorg = 3;
        } else if (this.idsyndicat === "scapp") {
          idorg = 1;
        } else if (this.idsyndicat === "Languedoc-Roussillon") {
          idorg = 6;
        } else if (this.idsyndicat === "Vendee") {
          idorg = 4;
        } else if (this.idsyndicat === "SDEP") {
          idorg = 7;
        } else {
          console.log("no organisation selected");
          this.closeModal();
          return;
        }
        let results = await axios.get("/api/adt/contact", {
          params: { idorg: idorg },
        });

        if (results.data) {
          this.contactInfosUpdated = false;
          this.activeContact = results.data;
          this.originalContact = cloneDeep(this.activeContact);
          this.portableNumber = this.activeContact.telephone
            ? this.formatPhoneNumber(this.activeContact.telephone)
            : null;
        }
      } catch (error) {
        console.log(error);
      }
    },
    initContact() {
      this.activeContact = {
        idcontacts_syndicat: null,
        idadresse: null,
        titre: null,
        nom: null,
        prenom: null,
        telephone: null,
        email: null,
        note: null,
        idsyndicat: null,
        code_postal: null,
        id: null,
        ville: null,
        adresse: null,
        complement: null,
        cedex: null,
      };
      this.originalContact = cloneDeep(this.activeContact);
      this.contactInfosUpdated = false;
    },
    async saveContact() {
      this.showEditorContact = true;
      if (!this.contactInfosUpdated) {
        this.closeModal();
        return;
      }

      // todo handle messaging the user
      try {
        if (this.validName || this.validPPhone) {
          return;
        }
        let params = this.activeContact;
        await axios.put("/api/adt/contact", params);
        this.$emit("updateContact");
        this.closeModal();
      } catch (error) {
        console.log(error);
      }
    },
    closeModal() {
      this.showEditorContact = false;
      this.initContact();
      this.$emit("close");
    },

    removeWhiteSpace(str) {
      if (str) return str.replace(/ /g, "");
      return null;
    },
    trimOnPaste(entry) {
      if (entry == "siret") {
        setTimeout(() => {
          this.inputSiret = this.removeWhiteSpace(this.inputSiret);
        }, 200);
      }
      if (entry == "telephone") {
        setTimeout(() => {
          this.phoneNumber = this.removeWhiteSpace(this.phoneNumber);
        }, 200);
      }
      if (entry == "portable") {
        setTimeout(() => {
          this.portableNumber = this.removeWhiteSpace(this.portableNumber);
        }, 200);
      }
    },
    isNormalInteger(str) {
      var n = Math.floor(Number(str));
      return n !== Infinity && (String(n) === str || n === str) && n >= 0;
    },
    formatPhoneNumber(str) {
      if (str && isPhoneNumber(str)) {
        let newStr =
          str.slice(0, 2) +
          " " +
          str.slice(2, 4) +
          " " +
          str.slice(4, 6) +
          " " +
          str.slice(6, 8) +
          " " +
          str.slice(8, 10);
        return newStr;
      }
      return str;
    },
  },
};
</script>


<style lang="scss">
.padded-input {
  padding-left: 0.25rem;
}
.modify-etablissement-row {
  top: 0.5em;
}
.forcewidth-create-contact {
  width: 75vw;
  height: 60vh;
}
</style>
